import { ShopTypes } from '~/lib/data-contract';
import { useDeleteUser } from '~/services/shop/hooks';
import { useTranslations } from '~/services/umbraco/hooks';
import { Button } from '~/shared/components/Button';
import { ButtonWrapper, HeaderWrapper, SpacedText, StyledWrapper, WordBreakText } from './styled';

type Props = {
    handleClose: () => void;
    user: ShopTypes.CustomerUserItemDto | undefined;
    customerId?: string;
};

export default function DeleteUser({ handleClose, user, customerId }: Props) {
    const { mutate: deleteUser } = useDeleteUser();
    const { translate } = useTranslations();

    return (
        <StyledWrapper>
            <HeaderWrapper>
                <SpacedText as="h2" variant="display2">
                    {translate('mit-fog.userList.delete')}
                </SpacedText>
                <WordBreakText as="h2" variant="display2">
                    {user?.email}
                </WordBreakText>
            </HeaderWrapper>

            <WordBreakText>
                {translate('mit-fog.userList.deleteUser').replace('[EMAIL]', ` ${user?.email}`)}
            </WordBreakText>

            <ButtonWrapper>
                <Button variant="stroke" noIcon onClick={handleClose}>
                    {translate('mit-fog.userProfile.userInformation.cancel')}
                </Button>
                <Button
                    variant="fill"
                    noIcon
                    onClick={() =>
                        deleteUser(
                            {
                                customerId: customerId ?? null,
                                userId: user?.userId ?? null,
                            },
                            {
                                onSuccess: () => {
                                    handleClose();
                                },
                            },
                        )
                    }
                >
                    {translate('mit-fog.userList.approve')}
                </Button>
            </ButtonWrapper>
        </StyledWrapper>
    );
}
